import { render, staticRenderFns } from "./shortcut-menus-small.vue?vue&type=template&id=6c0852a6&scoped=true"
import script from "./shortcut-menus-small.vue?vue&type=script&lang=js"
export * from "./shortcut-menus-small.vue?vue&type=script&lang=js"
import style0 from "./shortcut-menus-small.vue?vue&type=style&index=0&id=6c0852a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0852a6",
  null
  
)

export default component.exports